// Action creator
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { Worker } from "../Worker";
/**
 * Worker that observes the page visibility changes and updates the app background state accordingly.
 * This is a Web client only worker that observes the document visibility state.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState Document.visibilityState}
 */ export class PageVisibilityObserverWorker {
    init() {
        if (!this.initialized) {
            // Set background state with the current visibility state on init
            this.onVisibilityChange();
            // Register visibility change event listener
            document.addEventListener("visibilitychange", this.onVisibilityChange);
            this.initialized = true;
        }
    }
    get name() {
        return Worker.PageVisibilityObserver;
    }
    /**
     * Creates a new instance of the PageVisibilityObserverWorker
     * @param actionCreatorLoader ActionCreator loader
     */ constructor(actionCreatorLoader){
        this.actionCreatorLoader = actionCreatorLoader;
        /** Indicates if the worker has been initialized */ this.initialized = false;
        /**
     * Event handler for the visibilitychange event
     */ this.onVisibilityChange = ()=>{
            const isPageInBackground = document.visibilityState === "hidden";
            const appContextActionCreator = this.actionCreatorLoader.load(ActionCreator.AppContext);
            appContextActionCreator.updateAppBackgroundState(isPageInBackground);
        };
    }
}
